import { Pipe, PipeTransform } from '@angular/core';

/**
 * A person's last-4 SSN with its label or separator, or nothing when there is no last-4.
 * Since Bug 36069 Sparta sends last-4 only for names two HRRM people share, so a label
 * built by concatenation would leave a dangling "SSN: " or " | " (Bug 36707).
 *
 * `[text]="item?.last4SSN | last4Label: 'SSN: '"`
 */
@Pipe({ name: 'last4Label', standalone: true, pure: true })
export class Last4LabelPipe implements PipeTransform {
  transform(last4: string | null | undefined, prefix = ''): string {
    const value = last4?.trim();
    return value ? `${prefix}${value}` : '';
  }
}
